import { styled } from '@mui/material';

import { SyntheticEvent, useEffect, useMemo, useState } from 'react';

import { RunStepExplanationProps } from '@app-velocity/libs/report';
import {
  Discussion,
  useDiscussionContext,
} from '@app-velocity/modules/scenarios';
import { Tabs } from '@app-velocity/ui';

import { RunStepExplanation } from '../../../RunStepExplanation';

const StyledTabPanel = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

type RunStepDetailsTab = 'thinking' | 'conversation';

export type FigmaRunStepDetailsTabsProps = RunStepExplanationProps & {
  challenge?: string;
  takenAction?: string;
  element?: string;
  explanation?: string;
};

export const FigmaRunStepDetailsTabs = ({
  view,
  stepNumber,
  reviewId,
  challenge,
  takenAction,
  element,
  explanation,
}: FigmaRunStepDetailsTabsProps) => {
  const [activeTab, setActiveTab] = useState<RunStepDetailsTab>('thinking');
  const { messages } = useDiscussionContext();
  const conversationCount = messages?.length ?? 0;

  const tabs = useMemo(
    () => [
      {
        label: 'prototypes:thinking_tab' as const,
        value: 'thinking',
      },
      {
        label: 'prototypes:conversation_tab' as const,
        value: 'conversation',
        labelOptions: { count: conversationCount },
      },
    ],
    [conversationCount]
  );

   
  useEffect(() => {
    setActiveTab('thinking');
  }, [stepNumber, reviewId]);

  const handleTabChange = (_event: SyntheticEvent, value: string) => {
    setActiveTab(value as RunStepDetailsTab);
  };

  return (
    <>
      <Tabs tabs={tabs} value={activeTab} onChange={handleTabChange} />
      <StyledTabPanel>
        {activeTab === 'thinking' ? (
          <RunStepExplanation
            view={view}
            stepNumber={stepNumber}
            reviewId={reviewId}
          />
        ) : (
          <Discussion
            challenge={challenge}
            takenAction={takenAction}
            element={element}
            explanation={explanation}
          />
        )}
      </StyledTabPanel>
    </>
  );
};
